import React from 'react'
import {
  Icon,
  Li,
  Container,
  Subtitle,
  Text,
  Button,
  Wrapper
} from './SelectEntityItem.style'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import { useHistory } from 'react-router-dom'
import { ADMIN_SELECT_ENTITY_PATH } from 'routes/paths'
import type { SelectEntityItemProps } from './SelectEntityItem.types'
import useUserPlatform from 'utils/hooks/use-platform'
import useFeatureToggles from 'utils/hooks/use-feature-toggles'

const SelectEntityItem: React.FC<SelectEntityItemProps> = ({ entityName }) => {
  const history = useHistory()
  const { isSmallerThanTablet } = useUserPlatform()
  const { featureToggles } = useFeatureToggles()
  const hasBiblionGeneral = featureToggles?.biblionGeneral

  return (
    <Li onClick={() => history.push(ADMIN_SELECT_ENTITY_PATH)}>
      <Wrapper>
        <Icon
          iconName={'school'}
          color={tokens.colors.dark5}
          size={16}
          sizeMobile={16}
        />
        <Container>
          <Subtitle color={tokens.colors.dark4}>{'Você está em:'}</Subtitle>
          <Text color={tokens.colors.dark5}>
            {hasBiblionGeneral ? 'BibliON' : entityName}
          </Text>
        </Container>
      </Wrapper>
      <Button
        theme={{
          type: 'secondary',
          size: isSmallerThanTablet ? 'small' : 'medium'
        }}
        text={hasBiblionGeneral ? 'Trocar' : 'Trocar de unidade'}
        fluid
        iconName="rotate"
        isLeft
      />
    </Li>
  )
}
export default SelectEntityItem
